/*
Notes:
- This function relies on having the Color variant first and the Size variant second in ALL products
- 
*/

function selectVariant(elem, option, isColor, index) {
    // Only affect options that have the class .disable-option
    if (!$(elem).hasClass('disable-option')) {

        // Update .selected-value class to highlight current option
        $(elem).closest('.option-value').find('.value-container').removeClass('selected-value');
        $(elem).addClass('selected-value');

        // Construct the selection option title (this is using the hidden select)
        var selectionOptionTitle = "";
        var optionWrappers = $('.product-option-wrapper .option-wrapper');
        for (var i = 0; i < optionWrappers.length; i++) {
            var optionText = $(optionWrappers[i]).find('.option-value .selected-value').data('value');
            selectionOptionTitle = selectionOptionTitle + ' \/ ' + optionText;
        }
        selectionOptionTitle = selectionOptionTitle.trim().substring(2);

        // Update the selected option in the product select dropdown
        if ($('#productSelect option:contains("' + selectionOptionTitle + '")').length > 0) {
            $('#productSelect option:contains("' + selectionOptionTitle + '")').prop('selected', true);

            // Update the product image and price based on the selected variant
            if ($('.product-images .slick-carousel').hasClass('slick-initialized')) {
                var imageIndex = $('#productSelect').find(":selected").data('imgid');
                var slickIndex = $('.slick-carousel [data-imgid="' + imageIndex + '"]:not(.slick-cloned)').data('slickIndex');
                if ($('.slick-carousel img').length > 2) {
                    $('.slick-carousel').slick('slickGoTo', slickIndex);
                }
            }

            // Enable/disable Add to Cart button and update price based on variant availability
            if ($('#productSelect').val() == null) {
                $('.add-cart #addToCart').prop('disabled', true);
            } else {
                $('.add-cart #addToCart').prop('disabled', false);
                $('.price .actual-price').html($('#productSelect').find(":selected").data('price'));
            }

            // Handle option updates when a specific option is selected - 'optionIndex == 1' refers to the Color variant options
            var optionIndex = $(elem).data("optionindex");
            var optionWrappers = $('.product-option-wrapper .option-wrapper');
            if (optionIndex == 1 && optionWrappers.length == 2) {
                var currentValue = $(optionWrappers[0]).find('.option-value .selected-value').data('value');
                var options2 = $(optionWrappers[1]).find('.option-value .value-container');
                for (var j = 0; j < options2.length; j++) {
                    var optionText = currentValue + ' \/ ' + $(options2[j]).data('value');
                    var $matchingOptionText = $('#productSelect option:contains("' + optionText + '")');
                    if ($matchingOptionText.length > 0 && !$matchingOptionText.prop('disabled')) {
                        $(options2[j]).removeClass("disable-option");
                    } else {
                        $(options2[j]).addClass("disable-option");
                    }
                }
            } else if (optionIndex == 2 && optionWrappers.length == 2) {
              /*
                var currentValue = $(optionWrappers[1]).find('.option-value .selected-value').data('value');
                var options1 = $(optionWrappers[0]).find('.option-value .value-container');
                for (var j = 0; j < options1.length; j++) {
                    var optionText = $(options1[j]).data('value') + ' \/ ' + currentValue;
                    var $matchingOptionText = $('#productSelect option:contains("' + optionText + '")');
                    if ($matchingOptionText.length > 0 && !$matchingOptionText.prop('disabled')) {
                        $(options1[j]).removeClass("disable-option");
                    } else {
                        $(options1[j]).addClass("disable-option");
                    }
                }
              */
            }
            
            // Add "Almost gone!" span element if inventory is less than 4
            var inventory = $('#productSelect').find(":selected").data('inventory');
            if (inventory !== undefined && inventory < 4) { 
              // Check if the span element already exists
              var almostGoneSpan = $('.product-option-wrapper').find('.almost-gone');
              if (almostGoneSpan.length === 0) {
                var spanElement = $('<span>').addClass('almost-gone').text('Almost gone!');
                $('.size-option').after(spanElement);
              }
            } else {
              // Remove the span element if inventory is 4 or more
              $('.product-option-wrapper').find('.almost-gone').remove();
            }

            /*
            // TO DO: Update the variant in the current URL.
            // Need to make the URL update with variant ID, not the text name of the variant:
              var urlParams = new URLSearchParams(window.location.search);
              urlParams.set('variant', option);
              var newURL = window.location.pathname + '?' + urlParams.toString();
              window.history.replaceState(null, null, newURL);
            */

        } else {
            // If the selected option in the product select dropdown isn't updated i.e. '#productSelect option' doesn't change
            $('.add-cart #addToCart').prop('disabled', true);
            if (isColor) {
                var imageIndex = $('#productSelect [data-option' + index + '="' + option + '"]:eq(0)').data('imgid');
                var slickIndex = $('.slick-carousel [data-imgid="' + imageIndex + '"]:not(.slick-cloned)').data('slickIndex');
                $('.slick-carousel').slick('slickGoTo', slickIndex);
            }
        }
    }
}

// Run code when document ready
$(document).ready(function() {
    var initOption = $('.product-option-wrapper .option-wrapper:eq(0)').find('.option-value .selected-value');
    $(initOption).removeClass('selected-value');
    $(initOption).click();  
});
